import appEnvironment from '../app-environment';

const _isFileUrl = (url) => {
    const match = url.match(/^file:\/?\/?([a-zA-Z\s.\-_/0-9]*)/);

    if (match) {
        return match[1];
    }
    return null;
};

const aGetResponse = async ({ url, options, page }) => {
    let urlToUse = url;
    const fileUrl = _isFileUrl(urlToUse);

    let fetchFnc;

    // For nodejs based programs, the fetch function is injected via
    // the fetch property of the appEnvironment. That way we do not add node-fetch
    // to the web-app dependencies. This is the same pattern used for fs as well

    if (typeof fetch === 'undefined') {
        fetchFnc = appEnvironment.getVar('fetch');
    } else {
        fetchFnc = fetch;
    }

    if (fileUrl) {
        const fs = appEnvironment.getVar('fs');

        if (!fs) {
            throw new Error('If file protocol, fs must be mocked');
        }

        return new Promise((resolve, reject) => {
            fs.readFile(fileUrl, (err, buffer) => {
                if (err) {
                    return reject(err);
                }

                resolve({
                    json: () => JSON.parse(buffer.toString()),
                    arrayBuffer: () => buffer,
                });
                return null;
            });
        });
    }
    if (options && options.pagination && options.pagination.enabled) {
        let separator = '&';

        if (urlToUse.indexOf('?') === -1) {
            separator = '?';
        }
        urlToUse = `${urlToUse}${separator}page=${page}`;
    }
    let response;
    try {
        const debugging = appEnvironment.getVar('debugging');
        if (debugging) {
            console.log(`Fetching: ${urlToUse}`);
        }

        response = await fetchFnc(urlToUse, options);
    } catch (e) {
        console.error(e);
        throw e;
    }
    return response;
};

const aFetch = async ({ url, type, options }) => {
    let result;
    let page = 1;
    let usePagination = false;
    let fetchAllPages = false;

    let done = false;

    if (options && options.pagination && options.pagination.enabled) {
        usePagination = true;
        fetchAllPages = options.pagination.fetchAll;
        result = [];
    }

    const _loopPages = async () => {
        while (!done) {
            const response = await aGetResponse({ url, options, page });

            done = true;
            switch (type) {
                case 'json':
                    try {
                        const subResult = await response.json();

                        if (usePagination) {
                            if (
                                fetchAllPages &&
                                subResult &&
                                subResult.pagination &&
                                subResult.pagination['has_more_items']
                            ) {
                                done = false;
                                page += 1;
                            }
                            result.push(subResult);
                        } else {
                            result = subResult;
                        }
                    } catch (e) {
                        if (usePagination) {
                            result = [];
                        } else {
                            result = {};
                        }
                    }
                    break;
                case 'binary':
                    result = await response.arrayBuffer();
                    break;
                default:
                    result = await response.text();
            }

            if (options && options.retrieveHeaders) {
                result = { body: result, headers: response.headers || {} };
            }
        }
    };

    await _loopPages();
    return result;
};

const sFetch = {
    aFetch,
};

export default sFetch;
